export const TYPES = {
  Vue: Symbol.for('Vue'),
  VueRouter: Symbol.for('VueRouter'),
};

export type OrderType = 'ASC' | 'DESC';